const formatDate = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

/** Add initial dashboard dates without replacing filters from a shared URL. */
export const withDashboardDefaults = (search: string, now = new Date()) => {
  const params = new URLSearchParams(search);
  const setMissing = (key: string, value: string) => {
    if (!params.has(key)) params.set(key, value);
  };
  const monthStart = formatDate(new Date(now.getFullYear(), now.getMonth(), 1));
  const monthEnd = formatDate(
    new Date(now.getFullYear(), now.getMonth() + 1, 0),
  );

  if (!params.has("assignment_date_range")) {
    setMissing("calendar_type", "year");
    if (params.get("calendar_type") === "year") {
      setMissing("year", String(now.getFullYear()));
      const year = params.get("year") ?? String(now.getFullYear());
      setMissing("assignments_from", `${year}-01-01`);
      setMissing("assignments_to", `${year}-12-31`);
    } else if (params.get("calendar_type") === "month") {
      setMissing("assignments_from", monthStart);
      setMissing("assignments_to", monthEnd);
    }
  }

  setMissing("issues_from", monthStart);
  setMissing("issues_to", monthEnd);
  return params.toString();
};
